import { makeStyles } from '@rbx/ui';
import React, { FunctionComponent } from 'react';

type PrimarySvgProps = {
  width?: number | undefined;
  height?: number | undefined;
  viewBox?: string | undefined;
};

const usePrimarySvgStyles = makeStyles()((theme) => ({
  logo: {
    color: theme.palette.text.primary,
  },
}));

const PrimarySvg: FunctionComponent<React.PropsWithChildren<PrimarySvgProps>> = ({
  width,
  height,
  viewBox,
  children,
}) => {
  const {
    classes: { logo },
  } = usePrimarySvgStyles();

  return (
    <svg
      className={logo}
      width={width}
      height={height}
      viewBox={viewBox}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      {children}
    </svg>
  );
};

export default PrimarySvg;
